import { render } from "./App.vue?vue&type=template&id=d0425f3c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d0425f3c&lang=less"
script.render = render

export default script